<template>
  <div id="wrapper">
    <div class="topBackground"></div>
    <div class="introduceDetails">
      <div>
        <div class="introducedTitle">险种介绍</div>
        <div class="informationEnglish">Product information</div>
      </div>
      <div class="productInformation"></div>
      <div class="advantage"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "introduced"
    }
</script>

<style scoped>
  .topBackground{
    max-height: 32.5rem;
    padding-top: 27%;
    background: url("../../static/images/dutyInsurance/introduced/introducedBanner.png") no-repeat center / cover;
  }

  .introduceDetails{
    margin-top: 6rem;
    overflow: hidden;
  }

  .introducedTitle{
    width: 100%;
    text-align: center;
    font-size: 1.75rem;
    font-weight: bold;
    color: #333333;
  }

  .informationEnglish{
    width: 100%;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 500;
    color: #CCCCCC;
  }

  .productInformation{
    float: left;
    width: 80%;
    max-height: 37.63rem;
    padding-top: 31.5%;
    background: url("../../static/images/dutyInsurance/introduced/productInformation.png") no-repeat center / cover;
    margin: 4rem 0;
  }

  .advantage{
    float: right;
    width: 80%;
    max-height: 37.56rem;
    margin-bottom: 7.5rem;
    padding-top: 32.4%;
    background: url("../../static/images/dutyInsurance/introduced/advantage.png") no-repeat center / cover;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/introduced.vue